export class ErrorValidatingSamlMessage {

    /* @ngInject */
    constructor($stateParams) {
        this.errorMessage = $stateParams.errorMessage;
    }

    ngInject() {}

}
